var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var SvgLocations = function (props) { return (_jsx("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "m11.86 5.5.4 2h5.24v6h-3.36l-.4-2H6.5v-6h5.36Zm1.64-2h-9v17h2v-7h5.6l.4 2h7v-10h-5.6l-.4-2Z", fill: "#000" }) }))); };
var Memo = memo(SvgLocations);
export default Memo;
//# sourceMappingURL=Locations.js.map